import * as types from './types';

export function toggleDrawerOpen() {
  return {
    type: types.RESPONSIVE_DRAWER_TOGGLE_DRAWER_OPEN
  };
}

export function toggleDrawerDock() {
  return {
    type: types.RESPONSIVE_DRAWER_TOGGLE_DRAWER_DOCK
  };
}

export function setDrawerOpen(open) {
  return {
    type: types.RESPONSIVE_DRAWER_SET_DRAWER_OPEN,
    open: open
  };
}

export function setResponsive(responsive) {
  return {
    type: types.RESPONSIVE_DRAWER_SET_RESPONSIVE,
    responsive: responsive
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-responsive-drawer/es/store/actions.js
// module id = 7WXb
// module chunks = 0